import { useState } from 'react';
import type { JSX, MouseEvent } from 'react';
import { Label, Select, SelectOption } from '@wistia/ui';
import { trackStructEvent } from '~/utilities/snowplow';
import type { DownloadableMediaFile } from '~/singlePageApp/components/DownloadModal';
import { DownloadButton, SelectWrapper, TabWrapper } from './SharedStyledComponents';

type Props = {
  downloadableMediaFiles: DownloadableMediaFile[];
};

export const AudioMediaTab = ({ downloadableMediaFiles }: Props): JSX.Element => {
  const [selectedFormat, setSelectedFormat] = useState('uncompressed');
  const encoded = downloadableMediaFiles.find((file) => file.displayName === 'mp3 encode');
  const uncompressed = downloadableMediaFiles.find((file) => file.displayName === 'Original File');
  const selectedAudio =
    (selectedFormat === 'uncompressed' ? uncompressed : encoded) ?? ({} as DownloadableMediaFile);

  const onChange = (value: string) => {
    setSelectedFormat(value);
  };

  const trackEvent = (_event: MouseEvent) => {
    window.open(selectedAudio.downloadUrl, '_blank');

    trackStructEvent({
      category: 'button',
      action: 'click',
      label: `publish-download-${selectedFormat}-audio`,
    });
  };

  return (
    <TabWrapper>
      <SelectWrapper>
        <Label>Format</Label>
        <Select
          onChange={onChange}
          value={selectedFormat}
          fullWidth={true}
        >
          <SelectOption value="uncompressed">Uncompressed</SelectOption>
          <SelectOption value="encoded">Encoded</SelectOption>
        </Select>
      </SelectWrapper>
      <DownloadButton onClick={trackEvent}>Download</DownloadButton>
    </TabWrapper>
  );
};
